export function shapeAndOpenBooster1()
{
    const pull1 = [1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 3, 3, 3, 4]
    const pull2 = [5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 7, 7, 7, 8]
    const pull3 = [9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 10, 11, 11, 11, 12]
    const finalPull = [...pull1, ...pull2, ...pull3]
    return get_random(finalPull)
}

export function shapeAndOpenBooster2()
{
    const pull = [13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15, 15, 16]
    return get_random(pull)
}


export function get_random (list) {
    return list[Math.floor((Math.random()*list.length))];
}
  